import CookieConsent from './modules/cookie-consent';
import addWindowScrollPositionToDocument from './modules/viewport';
import initMenu from './modules/menu';
import initProcesPopups from './modules/process-popup';
import initVideoPopup from './modules/video-popup';
import initTopics from './modules/topic';

addWindowScrollPositionToDocument();

initMenu();
initProcesPopups();
initVideoPopup();
initTopics();

window.onload = () => {
    // Cookie consent
    const cookieConsent = new CookieConsent(document);
    if (document.querySelector('[data-cmeleon-cookie-notice]') !== null) {
        setTimeout(() => cookieConsent.showNotice(), 2000);
    }
};

document.onkeydown = function (e) {
    // Close items with escape
    if (e.key === 'Escape') {
        // Menu item with children
        const menuItemWithChildren = document.querySelector('.menu-item-with-children');
        menuItemWithChildren.classList.remove('menu-item-with-children-triggered');

        // Comment form
        document.querySelectorAll('.comment-form-popup-wrapper').forEach((el) => {
            el.classList.add('hidden');
            el.setAttribute('aria-expanded', 'false');
        });

        // Mobile menu
        const mainMenu = document.querySelector('[data-main-menu]');
        mainMenu.classList.add('hidden');

        const hamburgerMenuIcon = document.querySelector('[data-hamburger-menu-icon]');
        hamburgerMenuIcon.classList.remove('hidden');

        const closeMenuIcon = document.querySelector('[data-close-menu-icon]');
        closeMenuIcon.classList.add('hidden');
    }

    // Lock focus inside mobile menu
    if (document.body.clientWidth < 992) {
        const menu = document.querySelector('[data-main-menu]');
        const firstFocusableElement = menu.querySelectorAll('a')[0];
        const focusableContent = menu.querySelectorAll('a');
        const lastFocusableElement = focusableContent[focusableContent.length - 1];

        const isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    }
};
